<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Nova Cooperativa' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Cooperativas',
                href: '#/cooperatives',
              },
              {
                text: 'Cadastro Cooperativa',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Nome">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="CNPJ">
                <b-form-input
                  v-model="state.socialNumber"
                  required
                  placeholder="Informe o CNPJ"
                  :state="isOk('socialNumber')"
                  v-mask="['##.###.###/####-##']"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('socialNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Email">
                <b-form-input
                  v-model="state.email"
                  required
                  placeholder="Informe o email"
                  :state="isOk('email')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('email')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Denominação">
                <b-form-input
                  v-model="state.denomination"
                  required
                  placeholder="Informe a denominação"
                  :state="isOk('denomination')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('denomination')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Endereço"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.address"
                  placeholder="Informe o Endereço"
                  :state="isOk('address')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('address')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Numero"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.number"
                  placeholder="Informe o Número"
                  :state="isOk('number')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('number')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Complemento"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.complement"
                  placeholder="Informe o Complemento"
                  :state="isOk('complement')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('complement')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Telefone"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.phone"
                  required
                  placeholder="Informe o Telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :state="isOk('phone')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('phone')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Cidade"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.city"
                  placeholder="Informe a Cidade"
                  :state="isOk('city')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('city')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Bairro"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.district"
                  placeholder="Informe o Bairro"
                  :state="isOk('district')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('district')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Estado"
                label-for="input-1"
              >
                <b-form-select
                  v-model="state.state"
                  :options="viewData.states"
                  :state="isOk('state')"
                >
                  <option disabled value>Selecione um estado</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('state')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="CEP" label-for="input-1">
                <b-form-input
                  v-model="state.zipCode"
                  placeholder="Informe o CEP"
                  :state="isOk('zipCode')"
                  v-mask="['#####-###']"
                  @blur="fillCompleteAddress($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('zipCode')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Observações"
                label-for="input-2"
              >
                <b-form-textarea
                  v-model="state.notes"
                  placeholder="Informe as observações"
                  rows="3"
                  max-rows="6"
                  :state="isOk('notes')"
                ></b-form-textarea>
                <b-form-invalid-feedback>{{
                  getError('notes')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import StatesJson from '../../vue/estados.json';

const API = new Api();

export default {
  name: 'cooperative-edit',
  data: function() {
    return {
      state: {
        name: '',
        socialNumber: '',
        denomination: '',
        notes: '',
        state: '',
        email: '',
        phone: '',
        zipCode: '',
        complement: '',
        number: '',
        city: '',
        district: '',
        address: '',
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    this.viewData.states = StatesJson.estados;
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/cooperative/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    async save() {
      try {
        let data = _.cloneDeep(this.state);
        data.socialNumber = _.replace(data.socialNumber, '.', '');
        data.socialNumber = data.socialNumber
          .replace(/\./g, '')
          .replace(/\-/g, '')
          .replace(/\//g, '');

        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/cooperative/${this.viewData.id}`
            : '/cooperative/',
          method: this.viewData.id ? 'put' : 'post',
          data: data,
        });

        this.$toast.success('Cooperativa incluída com sucesso');

        this.$router.push('/cooperatives');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
